<template>
    <div v-show="wizard.show" class="bg-white my-3" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
        <div v-if="wizard.current_step > 0" class="d-flex align-items-center justify-content-around mb-3 p-4">
            <div @click="goto_step(1)" :style="wizard.current_step > 0 ? 'cursor: pointer !important;' : ''">
                <div class="text-center mt-2">
                    <span :style="wizard.current_step > 0 ? 'color: #00bea5' :'color: #d2d2d2'">{{
                            $t('pos.customer_detail')
                        }}</span>
                </div>
            </div>
            <div @click="goto_step(2)" :style="wizard.current_step > 1 ? 'cursor: pointer !important;' : ''">
                <div class="text-center mt-2">
                    <span :style="wizard.current_step > 1 ? 'color: #00bea5' :'color: #d2d2d2'">{{
                            $t('pos.account_detail')
                        }}</span>
                </div>
            </div>
            <div @click="goto_step(3)" :style="wizard.current_step > 2 ? 'cursor: pointer !important;' : ''">
                <div class="text-center mt-2">
                    <span :style="wizard.current_step > 2 ? 'color: #00bea5' :'color: #d2d2d2'">{{
                            $t('pos.device_info')
                        }}</span>
                </div>
            </div>
            <div @click="goto_step(4)" :style="wizard.current_step > 3 ? 'cursor: pointer !important;' : ''">
                <div class="text-center mt-2">
                    <span :style="wizard.current_step > 3 ? 'color: #00bea5' :'color: #d2d2d2'">{{
                            $t('pos.address_info')
                        }}</span>
                </div>
            </div>
            <div @click="goto_step(5)" :style="wizard.current_step > 4 ? 'cursor: pointer !important;' : ''">
                <div class="text-center mt-2">
                    <span :style="wizard.current_step > 4 ? 'color: #00bea5' :'color: #d2d2d2'">{{
                            $t('pos.documents')
                        }}</span>
                </div>
            </div>
        </div>

        <hr class="custom_hr" v-if="wizard.current_step > 0">

        <div class="p-5">
            <div v-show="wizard.current_step === 1">
                <get-customer-by-code :form_data="form_data" :wizard="wizard"></get-customer-by-code>
            </div>
            <div v-show="wizard.current_step === 2">
                <account-detail :wizard="wizard" :form_data="form_data"></account-detail>
            </div>
            <div v-show="wizard.current_step === 3">
                <device-info :wizard="wizard" :form_data="form_data"></device-info>
            </div>
            <div v-show="wizard.current_step === 4">
                <address-info :form_data="form_data" :wizard="wizard"></address-info>
            </div>
            <div v-show="wizard.current_step === 5">
                <documents :form_data="form_data" :wizard="wizard" :register="registerPosRequest"></documents>
            </div>
        </div>
    </div>
</template>

<script>


import toastr from "toastr";
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import getCustomerByCode from "./get-customer-by-code";
import AccountDetail from "./bank-account-detail";
import DeviceInfo from "./device-info";
import AddressInfo from "./address-info";
import PosDocuments from "./documents/pos-documents";
import {posService} from '@/common/api.service'
import {mapGetters} from "vuex";
import {KTApp} from '@/plugins/core/app';
import {KTUtil} from '@/plugins/core/util'


export default {
    components: {
        'device-info': DeviceInfo,
        'documents': PosDocuments,
        'address-info': AddressInfo,
        'get-customer-by-code': getCustomerByCode,
        'account-detail': AccountDetail,
    },
    props: {
        form_data: {
            required: true,
            default() {
                return {}
            },
        },
        wizard: {
            default() {
                return {}
            },

        },
    },
    data() {
        return {}
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
        ...mapGetters('pos', [
            'psp', 'constants'
        ])
    },
    mounted() {
        this.form_data = this.$store.state.pos.form_data
    },
    methods: {
        registerPosRequest(btn, form, hidden_btn) {
            KTApp.progress(btn)
            let bank_account_detail = structuredClone(this.form_data.bank_account_detail);
            delete bank_account_detail.multi_account_details
            delete bank_account_detail.multi_account_owners
            let customer_detail = structuredClone(this.form_data.customer_detail);
            delete customer_detail.signature_holder
            let params = {
                ...customer_detail, ...this.form_data.documents, ...this.form_data.address_info, ...this.form_data.device_info,
                stakeholders: this.form_data.stakeholders,
                multi_account_owners: this.form_data.sub_customers,
                ...this.form_data.customer_detail.signature_holder, ...bank_account_detail,
                status: this.form_data.status,
                psp: this.psp
            }
            for (let key in params) {
                if (params[key] == null) params[key] = ''
            }
            posService.addPosRequest(params).then(response => {
               this.$router.push('/pos')
            }).catch(({response}) => {
                let message = document.createElement('div')
                message.innerHTML = response.data.message
                Object.keys(response.data.data).forEach(function (item) {
                    var li = document.createElement('li')
                    li.innerText = response.data.data[item][0]
                    message.insertAdjacentElement('beforeend', li)
                })
              if (hidden_btn) hidden_btn.style.display = 'inline'
                KTApp.unprogress(btn)
                KTUtil.scrollTop();
                return this.showMsg(form, 'danger', message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        goto_step(selected_step) {
            if (this.wizard.navigable && (this.wizard.current_step > selected_step)) {
                this.wizard.current_step = selected_step;
            }
        },
    },
    afterDispatch() {
        setTimeout(
                $('.kt-selectpicker').selectpicker({
                    size: 6,
                    liveSearch: false,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_chose')

                }), 2000)
    },
    changeLabel() {
        let label = $('#is_multi_account_label')
        let checkbox = $('#is_multi_account')
        if (checkbox.is(':checked')) {
            label.html(i18n.t('label.active'))
        } else {
            label.html(i18n.t('label.inactive'))
        }
    },
}
</script>

<style scoped>

.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}

.filter_green {
    filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg) brightness(91%) contrast(101%);
}

.filter_gray {
    filter: invert(87%) sepia(1%) saturate(200%) hue-rotate(314deg) brightness(101%) contrast(86%);
}

.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>